import { useId } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export function AcademyAssistantIcon({
  size = 24
}) {
  const id = useId();
  const paint0 = `${id}-paint0`;
  const paint1 = `${id}-paint1`;
  const clip0 = `${id}-clip0`;
  const clip1 = `${id}-clip1`;
  const clip2 = `${id}-clip2`;
  const mask0 = `${id}-mask0`;
  return /*#__PURE__*/_jsxs("svg", {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M12 0.000123453L12 0.533576L3.65415 0.533577C1.93376 0.533577 0.533452 1.93389 0.533452 3.65427L0.533453 20.346C0.533453 22.0664 1.93376 23.4667 3.65415 23.4667L12 23.4667L12 24.0001L3.65415 24.0001C1.64037 24.0001 9.7737e-07 22.3598 8.89345e-07 20.346L1.59728e-07 3.65427C7.17024e-08 1.64049 1.64036 0.000123906 3.65415 0.000123818L12 0.000123453Z",
      fill: "#D20688"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24 3.65427L24 20.346C24 22.3598 22.3596 24.0001 20.3459 24.0001L12 24.0001L12 23.4667L20.3459 23.4667C22.0662 23.4667 23.4666 22.0664 23.4666 20.346L23.4666 3.65427C23.4665 1.93389 22.0662 0.533577 20.3459 0.533577L12 0.533577L12 0.000123978L20.3459 0.000123613C22.3596 0.000123525 24 1.64049 24 3.65427Z",
      fill: "#FF4800"
    }), /*#__PURE__*/_jsx("path", {
      d: "M20.3299 0L3.67815 0C1.6457 0 1.04907e-06 1.6457 1.04907e-06 3.67548L1.04907e-06 20.3299C1.04907e-06 22.3596 1.6457 24.0053 3.67815 24.0053L20.3299 24.0053C22.3596 24.0053 24.0053 22.3596 24.0053 20.3299L24.0053 3.67548C24.0053 1.6457 22.3596 0 20.3299 0ZM22.5277 14.2912C19.2043 16.7557 16.417 19.4763 14.2725 22.5437C13.0109 23.8053 10.9651 23.8053 9.70616 22.5437C7.35897 19.3456 4.61436 16.585 1.45099 14.2912C0.189377 13.0296 0.189377 10.9838 1.45099 9.72216C4.70505 7.2096 7.54035 4.49967 9.70616 1.46966C10.9651 0.208046 13.0109 0.208046 14.2725 1.46966C16.449 4.47566 19.1963 7.16426 22.5277 9.72216C23.7866 10.9838 23.7866 13.0296 22.5277 14.2912Z",
      fill: `url(#${paint0})`,
      fillOpacity: "0.3"
    }), /*#__PURE__*/_jsxs("g", {
      clipPath: `url(#${clip0})`,
      children: [/*#__PURE__*/_jsx("rect", {
        width: "12",
        height: "12",
        transform: "translate(6 6.00012)",
        fill: "white",
        fillOpacity: "0.01"
      }), /*#__PURE__*/_jsx("mask", {
        id: mask0,
        style: {
          maskType: 'alpha'
        },
        maskUnits: "userSpaceOnUse",
        x: "6",
        y: "6",
        width: "12",
        height: "13",
        children: /*#__PURE__*/_jsx("g", {
          clipPath: `url(#${clip1})`,
          children: /*#__PURE__*/_jsxs("g", {
            clipPath: `url(#${clip2})`,
            children: [/*#__PURE__*/_jsx("path", {
              d: "M17.2503 15.3846V10.9897C17.2502 10.4081 16.8636 9.90269 16.3011 9.75044L12.4463 8.71956L12.4441 8.71883C12.2294 8.66028 11.9997 8.66026 11.7849 8.71883L11.7835 8.71956L7.05825 9.98702L7.05606 9.98775C7.01685 9.99802 6.99973 10.0147 6.99014 10.028C6.97814 10.0448 6.96853 10.0705 6.96853 10.1016C6.96857 10.1327 6.97829 10.1591 6.99087 10.1767C7.00112 10.191 7.01902 10.2082 7.05862 10.2188L11.7835 11.4863L11.7853 11.4867C12.0001 11.5452 12.2293 11.5452 12.4441 11.4867L12.4463 11.4863L15.866 10.5711C16.0951 10.5098 16.3306 10.646 16.3919 10.8751C16.4531 11.1041 16.3173 11.3396 16.0883 11.401L12.6697 12.315L12.6701 12.3154C12.3074 12.4143 11.922 12.4142 11.5594 12.3154L6.83596 11.0483C5.87397 10.7896 5.86162 9.41284 6.83816 9.15682L11.5608 7.89009C11.923 7.79162 12.3079 7.7917 12.6701 7.89046L12.6697 7.89083L16.523 8.92134H16.5241C17.4611 9.17433 18.109 10.0191 18.109 10.9897V15.3846C18.109 15.6217 17.9166 15.8142 17.6795 15.8142C17.4424 15.8141 17.2503 15.6217 17.2503 15.3846Z",
              fill: "#141414"
            }), /*#__PURE__*/_jsx("path", {
              d: "M8.24669 14.5561V12.966C8.24669 12.7289 8.43876 12.5368 8.67589 12.5368C8.91303 12.5368 9.10509 12.7289 9.10509 12.966V14.5561C9.10512 14.713 9.18529 14.8504 9.29845 14.9216L9.34899 14.9479L9.35082 14.9487C11.1931 15.7351 13.0175 15.7351 14.8597 14.9487L14.8616 14.9479C15.0007 14.8893 15.1051 14.7355 15.1051 14.5561V12.966C15.1051 12.7289 15.2975 12.5368 15.5347 12.5368C15.7718 12.5368 15.9639 12.7289 15.9639 12.966V14.5561C15.9638 15.0516 15.6785 15.5355 15.1952 15.7393L15.1948 15.7389C13.1384 16.6163 11.0718 16.6164 9.01537 15.7389C8.53203 15.5351 8.24673 15.0516 8.24669 14.5561Z",
              fill: "#141414"
            })]
          })
        })
      }), /*#__PURE__*/_jsx("g", {
        mask: `url(#${mask0})`,
        children: /*#__PURE__*/_jsx("path", {
          d: "M6 6.00012H18V18.0001H6V6.00012Z",
          fill: `url(#${paint1})`
        })
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: paint0,
        x1: "0",
        y1: "0",
        x2: "23.9893",
        y2: "23.9893",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FB31A7"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5",
          stopColor: "#FF4800"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#FBDDD2"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: paint1,
        x1: "4.63415",
        y1: "12.0001",
        x2: "18.1058",
        y2: "18.0573",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#FF3842"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#D20688"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: clip0,
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white",
          transform: "translate(6 6.00012)"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: clip1,
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white",
          transform: "translate(6 6.00012)"
        })
      }), /*#__PURE__*/_jsx("clipPath", {
        id: clip2,
        children: /*#__PURE__*/_jsx("rect", {
          width: "12",
          height: "12",
          fill: "white",
          transform: "translate(6 6.00012)"
        })
      })]
    })]
  });
}